'use client';

import SectionHeader from '@/components/SectionHeader';
import Footer from '@/components/Footer';
import { Configuration } from '@/types/configuration';
import FormLead from '@/components/FormLead';
import WallJumbotron from '@/components/WallJumbotron';
import WithBoxes from '@/components/WithBoxes';
import LinePath from '@/components/LinePath';
import LightBlueTitle from '@/components/LightBlueTitle';
import { useRef } from 'react';


interface Props {
    configuration: Configuration
    csrfToken?: string
}

const Landing: React.FC<Props> = (props: Props) => {

    const ctaRef = useRef<HTMLDivElement | null>(null);

    const scrollToCta = () => {
        ctaRef.current?.scrollIntoView({ behavior: 'smooth' })
    }

    return (
        <>
            {!props.configuration.header ? null : <SectionHeader configurationHeader={props.configuration.header} />}
            {props.configuration.wall ? <WallJumbotron configurationWall={props.configuration.wall} actionButton={scrollToCta} /> : null}
            {!props.configuration.boxes ? null : <WithBoxes actionButton={scrollToCta} />}
            {!props.configuration.lightBlueTitle ? null : <LightBlueTitle actionButton={scrollToCta} />}
            {!props.configuration.linePath ? null : <LinePath actionButton={scrollToCta} />}
            <div ref={ctaRef} key="cta">
                {!props.configuration.form ? null : <FormLead configuratioForm={props.configuration.form} csrfToken={props.csrfToken} />}
            </div>
            {!props.configuration.footer ? null : <Footer configurationFooter={props.configuration.footer} />}
        </>
    );
};

export default Landing;
